import Axios from "./axios";

const endpoint = "/api/user";

export default {
  //사용자삭제
  //{"userId": 0}
  userDelete: (data) => Axios.post(`${endpoint}/delete`, data),

  //조건별 유저 목록 조회
  //{"accountName": "string","companyName": "string","companyType": "string","constructionName": "string","phoneNumber": "string","userName": "string"}
  userFilterInformation: (data) =>
    Axios.post(`${endpoint}/filter-information`, data),

  //아이디 찾기
  //{"phoneNumber": "string","userName": "string"}
  userFindAccountName: (data) =>
    Axios.post(`${endpoint}/find-accountname`, data),

  //비밀번호 찾기
  //{"accountName": "string","phoneNumber": "string","userName": "string"}
  userFindAccountPassword: (data) =>
    Axios.post(`${endpoint}/find-accountpassword`, data),

  //id 중복 확인
  //?????? 물어보기
  userIdDupplication: (data) => Axios.post(`${endpoint}/id-dup-check`, data),

  //사용자 단일 정보
  //{"userId": 0}
  userInformaion: (data) => Axios.post(`${endpoint}/information`, data),

  //회사에 따른 유저 목록 조회(샵담당자/가공장담당자 선택 버튼)
  userListOnCompany: (data) => Axios.post(`${endpoint}/list-on-company`, data),

  //현장에 대한 사용자 목록
  userListOnConstrucion: (data) =>
    Axios.post(`${endpoint}/list-on-construction`, data),

  //현장관리자 유저 목록 조회
  //없음
  userListOnFieldManager: (data) =>
    Axios.post(`${endpoint}/list-on-fieldmanager`, data),

  //사용자 수정
  //{"accountPassword": "string","compnayId": 0,"constIds": [0],"phoneNumber": "string","userId": 0,"userName": "string"}
  userModify: (data) => Axios.post(`${endpoint}/modify`, data),

  //폰중복 확인
  //{"phoneNumber": "string"}
  userPhoneDuppication: (data) =>
    Axios.post(`${endpoint}/phone-dup-check`, data),

  //유저등록
  //{"accountName": "string","accountPassword": "string","companyId": 0,
  //"constIds": [  0],"phoneNumber": "string","userName": "string"}
  userRegister: (data) => Axios.post(`${endpoint}/register`, data),

  //로그인
  //{"accountName": "string","accountPassword": "string"}
  userLogin: (data) => Axios.post(`${endpoint}/sign-in`, data),

  //로그아웃
  userLogout: (data) => Axios.post(`${endpoint}/sign-out`, data),

  //사용자 전체 목록
  userTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),

  //세션체크
  userSession: (data) => Axios.get(`${endpoint}/session-check`, data),
};
